import {WishlistForm} from "@/components/Wishlist/WishlistForm.tsx";
import {Headline} from "@telegram-apps/telegram-ui";
import {useAuthProfile} from "@/providers/AuthProfileProvider.tsx";
import {Wishlist} from "@/api/types.ts";
import {useNavigation} from "@/providers/NavigationProvider.tsx";
import {useTranslation} from "react-i18next";

export const CreateWishlistPage = () => {
  const { authProfile, setAuthProfile } = useAuthProfile();
  const { navigateToRoute } = useNavigation();
  const { t } = useTranslation();

  if (!authProfile) {
    throw new Error("CreateWishlistPage must be inside the AuthProfileProvider");
  }

  const onWishlistSaved = (wishlist: Wishlist) => {
    authProfile.wishlistPreviews.push({...wishlist, wishesCount: 0});
    setAuthProfile({...authProfile});
    navigateToRoute(`/main/wishlists/${wishlist.id}`, true);
  }

  return (
    <div className={"p-3 pb-10"}>
      <Headline className={"pl-2 text-center"} weight={"2"}>{t('wishlist.action.create')}</Headline>
      <WishlistForm onSaved={onWishlistSaved}/>
    </div>
  );
}
